module.exports = __webpack_public_path__ + "assets/img/ja-bbeb4a96.png";